import Alpine from "alpinejs";

Alpine.data("logoanimation", () => ({
    states: [
        [0, 0, 0, 0],
        [1, 0, 0, 0],
        [1, 0, 1, 0],
        [1, 1, 1, 0],
        [1, 1, 1, 1],
        [2, 1, 1, 1],
        [2, 1, 1, 0],
        [2, 2, 1, 0],
        [2, 2, 2, 0],
        [2, 2, 2, 2],
        [2, 2, 0, 2],
        [0, 2, 0, 2],
        [0, 0, 0, 2],
    ],
    position: 0,
    interval: null,
    init() {
        this.interval = setInterval(() => {
            this.step();
        }, 1000);
    },
    step() {
        if (this.position === this.states.length - 1) {
            this.position = 0;
            return;
        }
        this.position++;
    },
    animate: {
        ["x-transition"]() {},
    },
}));
